import moment from 'moment';

export default {
  install: function(Vue, options) {
    Vue.filter('formatarData', function(data, retornarSeVazio = '') {
      if (data) {
          return moment(String(data)).format('DD/MM/YYYY');
      }

      return data || retornarSeVazio;
    });
  }
}



// WEBPACK FOOTER //
// ./FrontEnd/filtros/formatar-data.js